import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
import WhatshotOutlinedIcon from "@mui/icons-material/WhatshotOutlined";

export const WORD_WHEEL_PACK_PRODUCT_KEY = "word_wheel_pack";

export const WORD_WHEEL_PACK_OFFERS = [
    {
        code: "classic",
        name: "Classic Challenge",
        price: "$1.99",
        priceKey: "ww_pack_classic",
        shopLine: "Easy to Start, Relaxing to Play",
        levelCount: 200,
        popup: "Simple words make solving a breeze. Enjoy a smooth, relaxing pace and reach the finish line quickly!",
        icon: SpaOutlinedIcon,
    },
    {
        code: "hard_quest",
        name: "Hard Quest",
        price: "$2.99",
        priceKey: "ww_pack_hard_quest",
        shopLine: "A True Test of Skill",
        levelCount: 400,
        popup: "No 3-letter words here! Every puzzle features at least 5 longer words with challenging goals. Think you can handle the pressure?",
        icon: WhatshotOutlinedIcon,
    },
    {
        code: "master",
        name: "Master Quest",
        price: "$2.99",
        priceKey: "ww_pack_master",
        shopLine: "The Ultimate Journey",
        levelCount: 500,
        popup: "Starts gentle, then builds into serious brain-teasers. A long, rewarding challenge designed for true word masters!",
        icon: EmojiEventsOutlinedIcon,
    },
    {
        code: "daily_bundle",
        name: "Daily Bundle",
        price: "$1.99",
        priceKey: "ww_pack_daily_bundle",
        shopLine: "Opens unlimited daily puzzles.",
        popup: "",
        icon: CalendarMonthOutlinedIcon,
    },
];

export function wordWheelPackCheckoutPlan(offer) {
    return {
        name: offer.name,
        price: offer.price,
        productKey: WORD_WHEEL_PACK_PRODUCT_KEY,
        priceKey: offer.priceKey,
        successPath: "/puzzles/word-wheel",
    };
}

export function wordWheelPackOffer(code) {
    return WORD_WHEEL_PACK_OFFERS.find((offer) => offer.code === code) || null;
}
